'use client';

import type { ReactNode } from 'react';
import type { HasSelectItemFields } from '../../../../effect/utils/gtm/create/select-item';
import type { GtmListIdTypeT } from '@vs-shop/schemas/gtm/list-types';
import { captureCause } from '../../../../shared/utils/sentry';
import { Exit } from 'effect';

import { sendSelectItemEventAtomFn } from '../../../../effect/atom/gtm/sendSelectItemEvent';
import { useAtomSet } from '@effect/atom-react';

type Props = {
  listType: GtmListIdTypeT;
  children: ReactNode;
  product: HasSelectItemFields;
};

export default function ProductCardTracker({ listType, children, product }: Props) {
  const sendSelectItemEvent = useAtomSet(sendSelectItemEventAtomFn, { mode: 'promiseExit' });

  const handleClick = async () => {
    const exit = await sendSelectItemEvent({ product, listType });

    Exit.match(exit, {
      onFailure: (cause) => {
        captureCause(cause, {
          component: 'ProductCardTracker',
          action: 'Send select item event failed',
          additionalData: {
            productCode: product.code,
            listType,
          },
        });
      },
      onSuccess: () => {
        // nothing to do
      },
    });
  };

  return <div onClickCapture={handleClick}>{children}</div>;
}
